/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Smarts Conversation UI
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import MoserJS from 'bi/moser/moser.min'

/**
 *
 * Returns the JSON of a partial copy of the current Moser module containing only the query subjects for the given
 * columnIds and/or calculation.  This is required for Smarts alternate vis recommender.
 *
 * @param {array} An array of idForExpressions of columns
 */


export function shrinkTempModule(columnIds, tempModuleObject, logger) {

	function getColumnFromModule(columnId){
		return MoserJS.ModuleUtils.getMoserObjectByIdForExpression(columnId, tempModuleObject)
	}

	function getQuerySubjectFromColumn(column){
		let parent = column.getParent()
		while( parent ){
			if (parent.getObjectType() === MoserJS.MoserObjectTypes.QUERY_SUBJECT) {
				return parent
			}
			parent = parent.getParent()
		}
	}

	const factory = MoserJS.createObjectFactory()
	let newModule = MoserJS.ModuleUtils.createModule(factory, tempModuleObject.getLabel(), tempModuleObject.getExpressionLocale())

	const relationships = tempModuleObject.getRelationship()
	if (relationships.length) {
		relationships.forEach(relationship => newModule.addRelationship(relationship.clone()))
	}

	let querySubjects = []
	const querySubjectInNewModule = querySubject => querySubjects.indexOf(querySubject.getIdentifier()) !== -1
	const isCalculation = column => column.getObjectType() === MoserJS.MoserObjectTypes.CALCULATION

	columnIds.forEach(columnId => {
		const moserColumn = getColumnFromModule(columnId)
		if (!moserColumn) {
			const errorMsg =  `Unknown column id ${columnId}`
			logger.error(errorMsg)
			throw( new Error( errorMsg ) )
		}

		const querySubject = getQuerySubjectFromColumn(moserColumn)

		if (querySubject && !querySubjectInNewModule(querySubject)) {
			querySubjects.push(querySubject.getIdentifier())
			newModule.addQuerySubject(querySubject.clone())
		} else if (!querySubject && isCalculation(moserColumn)) {
			newModule.addCalculation(moserColumn.getMoserObject().clone())
		} else {
			const errorMsg =  `Unknown column id ${columnId}`
			logger.error(errorMsg)
			throw( new Error( errorMsg ) )
		}

	})

	return newModule
}